import { useStoreState } from '@src/store/store';

import { TRestrictions } from '@src/common/types/restrictions';

export function useRestrictions(): TRestrictions {
  return useStoreState((state) => state.restrictions.entities);
}
